import { BillingFailedPage } from '@page/billing/billing-failed/billing-failed.page';
import { BillingSuccessPage } from '@page/billing/billing-success/billing-success.page';
import { PaymentHistoryPage } from '@page/payment-history/payment-history.page';

import { NavigationAside } from '@component/aside/navigation/navigation.aside';
import { Header } from '@component/header/header';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageNameLoader } from '@util/route/page-name-loader';

export const BillingRoutes: RouteConfigInterface[] = [
  {
    Header,
    Aside: NavigationAside,
    Component: BillingSuccessPage,
    ...pageNameLoader(RouteEnum.BillingSuccess),
  },
  {
    Header,
    Aside: NavigationAside,
    Component: BillingFailedPage,
    ...pageNameLoader(RouteEnum.BillingFailed),
  },
  {
    Header,
    Aside: NavigationAside,
    Component: PaymentHistoryPage,
    ...pageNameLoader(RouteEnum.PaymentHistory),
  },
];
